import { add } from "lodash";

export default {
  // Loading Page
  loading: {
    title: "Getting Your Workspace Ready",
    message: "Please wait while we prepare your dashboard..."
  },
  // Sidebar Navigation
  sidebar: {
    dashboard: "Dashboard",
    plans: "Plans",
    evaluation: "Evaluation",
    talentPool: "Talent Pool",
    reports: "Reports",
    notifications: "Notifications",
    switchOrg: "Switch Org",
    settings: "Settings"
  },
  // Talent Pool / Users Page
  talentPool: {
    relationshipAddedSuccessfully: "Relationship added successfully",
    relationshipRemovedSuccessfully: "Relationship removed successfully",
    relationshipSavedSuccessfully: "Relationship Saved Successfully",
    profileCard: "Profile Card",
    viewOptions: {
      plan: "Plan",
      hierarchy: "Hierarchy",
      network: "Network"
    },
    searchPlaceholder: "Search users...",
    networkSearchPlaceholder: "Search network...",
    hierarchySearchPlaceholder: "Search hierarchy...",
    // KVDR Notifications
    kvdrNotifications: {
      create: "Create",
      roleCreatedSuccessfully: "Role Created successfully",
      delete: "Delete",
      roleDeletedSuccessfully: "Role deleted successfully",
      addProfile: "Add Profile",
      profileAddedSuccessfully: "Profile added successfully",
      removeProfile: "Remove Profile",
      profileRemovedSuccessfully: "Profile removed successfully",
      roleUpdate: "Role Update",
      updatedSuccessfully: "Updated successfully",
      profileUpdate: "Profile Update",
      profileUpdatedSuccessfully: "Profile updated successfully"
    },
    title: "Talent Pool",
    reviewRequest: "Review Request",
    // Main talent pool
    noPendingRequest: "No pending request found",
    dropresume: "Drop Resumes to Import",
    processingResume: "Processing Resumes...",
    draganddropPopup: "Drag & Drop your resumes here",
    Clicktoselectfiles: "or click to select files",
    Supportedfileformats: "Supported file formats: PDF, DOC, DOCX, TXT.",
    Maxuploadsize: "Maximum 10 files per upload.",
    processingStatus: "Processing Status",
    importResumes: "Import Resumes",
    UploadNewResume: "Upload New Resume",
    choosefile: "Choose File",
    AddMembers: "Add Members",
    email: "Email",
    contact_info: "Contact Info",
    career_objective: "Career Objective",
    Upload_More_Resumes: "Upload More Resumes",
    accessLevel: "Access Level",
    roleTitle: "Role Title",
    firstName: "First Name",
    lastName: "Last Name",
    AddRelationship: "Add Relationship",
    RelationshipSavedSuccessfully: "Relationship Saved Successfully",
    RelationshipAddedSuccessfully: "Relationship added successfully",
    RelationshipRemovedSuccessfully: "Relationship removed successfully",
    processingComplete: "Processing Complete",
    uploadingAndParsing: "Uploading and Parsing...",
    parsingProfiles: "Parsing Profiles...",
    total_progress: "Total Progress",
    Batches_in_queue: "Batches in Queue",
    no_objective_provided: "No objective provided.",
    view_talent_card: "View Talent Card",
    skills: "SKILLS",
    deactivateUserTitle: "Deactivate User from Organization",
    areYouSure: "Are you sure you want to deactivate",
    fromThisOrganization: "from this Organization?",
    deactivate_user: "Deactivate User",
    deactivationInProgress: "Deactivation In Progress...",
    confirm: "Confirm",
    noEmailOnRecord: "No email on record for this user",
    Resume_Preview: "Resume Preview",
    processed: "processed",
    done: "Done",
    failed: "Failed",
    finish: "Finish",
    Resume_not_found: "Resume not found",
    we_could_not_find_resume: "We couldn't find a resume for",
    pleaseSelectFile: "Please select a supported file to upload it now.",
    verify: "Verify and Upload",
    uploading: "Uploading...",
    downloadResume: "Download Resume",
    previewNotAvailable: "Preview Not Available",
    importFrom: "Import from",
    uploadExcel: "upload excel",
    uploadResumes: "upload resumes",
    uploadResumesTooltip: "Import from Resumes (PDF)",
    orHRIS: "or HRIS",
    pendingRequest: "Pending Request",
    allUsers: "All Users",
    addNewEmployee: "Add New Employee Card",
    // Table headers
    name: "Name",
    email: "Email",
    maxRole: "Max Role",
    relationships: "Relationships",
    action: "Action",
    // User search
    searchUser: "Search User",
    userNotFound: "User not found.",
    // Relationship management
    member: "Member",
    relationship: "Relationship",
    addRelation: "Add relation",
    removeRelationship: "Remove Relationship",
    // Add employee form
    firstName: "First Name",
    lastName: "Last Name",
    roleTitle: "Role Title",
    save: "Save",
    // Import
    importFromExcel: "Import from Excel"
  },
  // Settings Help Page
  settingsHelp: {
    frequentlyAskedQuestions: "Frequently Asked Questions",
    question1: "How do I manage my organization settings?",
    question2: "How can I invite new members to my organization?",
    question3: "What are the different user roles and permissions?",
    question4: "How do I customize my organization's branding?",
    helpText: "This is placeholder help text. Please contact support for specific assistance with your organization settings and configuration."
  },
  // Create Organization
  createOrganization: {
    organizationName: "Organization Name",
    organizationUsername: "Organization Username",
    website: "Website",
    workEmail: "Work Email",
    location: "Location",
    organizationType: "Organization Type",
    primaryThemeColor: "Primary Theme Color",
    secondaryThemeColor: "Secondary Theme Color",
    about: "About",
    saveChanges: "Save Changes",
    usernameExists: "This username already exists",
    usernameAvailable: "This username is available",
    organizationTypeOptions: {
      business: "Business",
      academic: "Academic",
      recruiter: "Recruiter"
    },
    logo: {
      adjustTitle: "Adjust Organization Logo",
      save: "Save",
      uploadButton: "Upload Logo",
      incorrectFileType: "Incorrect File Type",
      incorrectFileTypeText: "Please upload a supported image file type, e.g. jpg, png, etc.",
      fileSizeExceeded: "Image File Size Exceeded",
      fileSizeExceededText: "The size of the profile picture should be less than 1MB."
    }
  },

  // Main Organizations List
  main: {
    select: "Select",
    acceptInvitation: "Accept Invitation",
    noOrganizationFound: "No Organization Found!",
    noOrganizationSubtext: "Curate your own organization first.",
    createOrganization: "Create Organization",
    myOrganizations: "My Organizations",
    viewAllOrganizations: "View All Organizations",
    pendingInvitation: "Pending",
    currentOrg: "Current Organization"
  },

  // Organization Dashboard
  organization: {
    welcomeBack: "Welcome Back! 👋",
    setupComplete: "Setup Complete!",
    setupProgress: "Setup: {step} of 4",
    copyLink: "Copy link",
    linkCopied: "Link copied",
    criticalRoles: "Critical Roles",
    talentPool: "Talent Pool",
    integrations: "Integrations",
    onboarding: "Onboarding",
    activeCandidates: "Active Candidates",
    connectedApps: "Connected Apps",
    pendingOnboards: "Pending Onboards",
    kvdrReportsCenter: "KVDR Reports Center",
    kvdrReportsDescription: "Dive deep into your key visual data reports and gain critical insights.",
    exploreReports: "Explore Reports >",
    talentPoolExplorer: "Talent Pool Explorer",
    talentPoolDescription: "Discover, analyze, and manage your top talent with comprehensive insights.",
    exploreTalentPool: "Explore Talent Pool >",
    thisMonth: "this month",
    goToOnboarding: "Go to Onboarding",

    addWebsiteLink: "Add website link",

    keyRoles: "Key Roles",
    activePlans: "Active Plans",
    completedPlans: "Completed Plans",
    viewCandidates: "View Candidates",
    accrossOrganization: "Across Organization",
    viewBoards: "View Boards",
    archived: "Archived/Finished",

    topRolesDistribution: "Top Roles Distribution",
    employees: "Employees",
    noData: "No data available yet.",

    plansVelocity: "Plans Velocity",
    pv_desc: "Comparison of active vs completed strategic plans.",
    active: "Active",
    completed: "Completed",

    kvdrReports: "KVDR Reports",
    kvdrReports_desc: "Generate insights and download visual reports",
    talentExplorer: "Talent Explorer",
    talentExplorer_desc: "Mange your candidates and employees",

    allSet: "All set!",
    stepInProgress: "Step In Progress:",
    completeProg: "Your organization profile is 100% complete.",
    incompleteProg: "You are on Step {onboardingStep} of 4. Complete your profile to unlock full features.",
    continueSetup: "Continue Setup",
    viewDetails: "View Details",

    onboardingSteps: {
      welcome: "Welcome",
      welcome_desc1: "Let's set up your talent pool to kick off your KVDR journey and power your talent strategy!",
      welcome_desc2: "Follow these steps to align talent to what truly drives business outcomes and build a data-backed talent ecosystem.",
      step1_title: "Define Organization Roles",
      step1_desc: "Structure teams around value-critical roles.",
      step2_title: "Add Talent",
      step2_desc: "Import people data from any source.",
      step3_title: "Evaluate",
      step3_desc: "Set up your indicators to evaluate talent based on what matters most to your organization.",
      step4_title: "Plan",
      step4_desc: "Turn insights into fitment, development & succession actions with talent plan for each role.",
      next: "Next",
      previous: "Previous",
      done: "Done",
      import: "Import &",
      finish: "Finish",

      step1: {
        title: "Organization Structure",
        description: "We have initialized your organization workspace. Click below to customize your departments, roles, and hierarchy settings in the Organization Planner.",
        departments: "Departments",
        departments_desc: "Manage business units",
        roles: "Roles",
        roles_desc: "Define job titles",
        hierarchy: "Hierarchy",
        hierarchy_desc: "Set reporting lines",
        instructions: "Click any card above to open the Organization Planner, or click 'Next' to proceed to Import.",
      },

      step2: {
        title: "Choose your upload method",
        title2: "Resume Files",
        description: "Drag & drop or Click to browse",
        instructions: "Supported formats: PDF, .txt, .doc, .docx",
      },

      step4: {
        title: "Final Step: ",
        title2: "You are on Step 4 of 4. Review your talent insights below.",
        button: "Finish Setup",
      },
    }
  },

  // Reports
  reports: {
    title: "Reports",
    nineCellMatrix: "9 Cell Matrix",
    xyPlot: "Scatter Plot",
    talentScoreCard: "Talent Scorecard",
    emptyReports: "Empty Reports",
    createKVDRFirst: "Create a KVDR and plan first to view reports",
    // XY Plot specific
    xAxis: "X-Axis",
    yAxis: "Y-Axis",
    bubbleSize: "Bubble Size",
    loadingChart: "Loading chart...",
    howToReadChart: "How to read this chart",
    positioning: "Positioning",
    horizontalPosition: "Horizontal position shows",
    verticalPosition: "Vertical position shows",
    bubbleRepresentation: "Bubble Representation",
    eachBubbleRepresents: "Each bubble represents an employee",
    sizeIndicates: "Size indicates",
    quadrants: "Quadrants",
    topLeft: "Top-Left",
    topRight: "Top-Right",
    bottomLeft: "Bottom-Left",
    bottomRight: "Bottom-Right",
    low: "Low",
    high: "High",
    interaction: "Interaction",
    hoverOverBubble: "Hover over any bubble",
    revealsDetailedMetrics: "Reveals detailed metrics for that employee",
    colorCoding: "Color coding",
    differentColorsHelp: "Different colors help distinguish employees",
    // Nine Cell Matrix specific
    nineCellMatrixTitle: "Nine-Cell Matrix Employee Categorization",
    methodologyDescription: "Standardized methodology based on Performance Score and Succession Readiness",
    loading: "Loading...",
    preparingMatrix: "Preparing the Nine-Cell Matrix...",
    noDataAvailable: "No data available",
    employeeAssessmentRequired: "Employee assessment data is required to display the Nine-Cell Matrix.",
    successionReadiness: "Succession Readiness",
    performanceScore: "Performance Score",
    bargain: "BARGAIN",
    bind: "BIND",
    backup: "BACKUP",
    onTrack: "ON TRACK",
    boost: "BOOST",
    build: "BUILD",
    bootBarter: "BOOT/BARTER",
    employees: "Employees",
    methodologyTitle: "Nine-Cell Matrix Methodology",
    methodologySubtitle: "Standardized employee categorization based on Performance Score and Succession Readiness calculations.",
    calculationMethod: "Calculation Method",
    performanceScoreFormula: "Performance Score (P)",
    performanceScoreCalculation: "P = 0.6 × Performance + 0.4 × Appraisal",
    performanceScoreNote: "Raw scores (-1 to 1.5) are normalized to 0-100 scale",
    successionReadinessFormula: "Succession Readiness (R)",
    successionReadinessCalculation: "R = 0.5 × Succession + 0.3 × Fitment + 0.2 × Years Score",
    successionReadinessNote: "Raw scores (-1 to 1.5) are normalized to 0-100 scale",
    yearsScore: "Years Score",
    yearsScoreCalculation: "If Years ≥ 3: 100, else: (Years / 3) × 100",
    yearsScoreNote: "Currently using default 2 years (configurable)",
    cellCategories: "Cell Categories",
    backupDescription: "High Performance, High Succession",
    boostDescription: "Medium Performance, High Succession",
    bindDescription: "High/Medium Succession, Low/Medium Performance",
    onTrackDescription: "Medium/Low Performance, Medium/Low Succession",
    buildDescription: "Medium Performance, Low Succession",
    bargainDescription: "Low Performance, High Succession",
    bootBarterDescription: "High Performance, Low Succession",
    // Talent Score Card specific
    criteria: "Criteria",
    talent: "TALENT",
    role: "ROLE",
    remarks: "REMARKS",
    weightage: "Weightage",
    good: "Good (8-10)",
    average: "Average (5-7)",
    poor: "Poor (1-4)",
    notApplicable: "Not Applicable"
  },


onboarding: {
    define_kvdr: "Define KVDRs - Critical Roles",
    align_talent: "ALIGN TALENT TO WHAT DRIVES BUSINESS",
    map_org: "Map your organization by identifying:",
    core_func: "Core functions & departments",
    kvdr: "Key Value Delivery Roles (roles that materially impact strategy & growth)",
    reporting: "Reporting lines and role criticality",
    outcome: "Outcome:",
    tile1: "A business-aligned organizational blueprint with a look of an org chart.",
    tile2: "A live, searchable talent pool ready for analysis; internal & external.",
    tile3: "Bias-reduced, forward-looking talent signals.",
    tile4: "Data-backed talent plans for hiring, upskilling, succession & growth.",
    completed: "Completed",
    start_now: "Start Now",
    pending: "Pending",
    talent_ecosystem: "Build Your Talent Ecosystem",
    single_source: "SINGLE SOURCE OF TRUTH FOR YOUR PEOPLE DATA",
    bring_workforce: "Bring your workforce into GetBoarded by:",
    uploading_cvs: "Uploading CVs, Excel, or role profiles",
    hris: "Connecting your HRIS (if available)",
    enrichment: "Enrichment with skills, abilities & aspirations",
    career_trajectories: "Evaluate Career Trajectories",
    beyond_performance: "BEYOND PERFORMANCE & POTENTIAL STATS",
    configure: "Configure how talent is assessed by:",
    gb_trajectories: "Using GetBoarded's trajectory models (Fitment, Performance, Succession)",
    custom_parameters: "Customizing parameters aligned to your context",
    weighing_signals: "Weighing signals that matter now and in future",
    talent_plans: "Generate Talent Plans",
    insights_to_execution: "TURN INSIGHTS INTO EXECUTION",
    unlock: "Instantly unlock:",
    role_talent: "Role-to-talent misalignment insights",
    risk_mapping: "Succession readiness & risk mapping",
    mobility: "Hiring, mobility & development plans", 
    define_org_roles: "Define Organization Roles",
    add_talent: "Add Talent",
    evaluate: "Evaluate",
    plan: "Plan",
  },


  // Users
  users: {
    title: "Users",
    manageUsers: "Manage Users",
    // User Recommendations
    talentRecommendations: "Talent Recommendations",
    recommendationsDescription: "Based on your KVDR assessment, here are personalized plans for your organization",
    viewActivePlans: "View Active Plans",
    // Recommendation Cards
    fitmentPlan: "Fitment Plan",
    fitmentPlanDescription: "Onboarding people to their roles.",
    fitmentPlanContent: "Onboarding people to their roles. Mapping right talent to right roles with fitment indicators",
    developmentPlan: "Development Plan",
    developmentPlanDescription: "AI-Powered Learning with ALEX",
    developmentPlanContent: "Creating Learning plans with ALEX Personalized learning paths to increase talent value with skills.",
    successionPlanning: "Succession Plan",
    successionPlanningDescription: "Promote and support career growth",
    successionPlanningContent: "Promote and support career growth Coaching plans for skill and time readiness to the next role.",
    // Benefits Lists
    roadToRole: "Road to your Role (Journey)",
    skillProfiling: "Skill profiling",
    learningCredits: "Learning credits",
    marketRewards: "Market rewards",
    customLearningPaths: "Custom learning paths",
    aiAssistedValidation: "AI assisted validation",
    progressTracking: "Progress tracking with Experience Points (XPs)",
    interactiveExercises: "Interactive exercises",
    appraisalIndicators: "360 Apprasial indicators",
    goalSettingMentorship: "Goal Setting & Mentorship",
    behaviouralCoaching: "Behavioural Coaching & Plans",
    managedCareerGuidance: "Managed Career Guidance",
    // Action Buttons
    onboard: "Onboard",
    activate: "Activate",
    promote: "Promote",
    // Progress Section
    talentCapabilitySnapshot: "Talent Capability Snapshot",
    lastUpdated: "Last updated: Today",
    refresh: "Refresh",
    // Score Labels
    industryLeader: "Industry Leader",
    highPerforming: "High Performing",
    competitive: "Competitive",
    developing: "Developing",
    foundationBuilding: "Foundation Building",
    // Notifications
    alexActivated: "ALEX Activated",
    alexActivatedText: "Your AI learning assistant is ready to help!",
    coachingRequestSent: "Coaching Request Sent",
    coachingRequestSentText: "A coach will contact you shortly!",
    rewardsMarketplace: "Rewards Marketplace",
    rewardsMarketplaceText: "Exploring available rewards and perks!"
  },

  // Integrations
  integrations: {
    title: "Integrations",
    manageIntegrations: "Manage Integrations"
  },

  // Admins
  admins: {
    title: "Admins",
    manageAdmins: "Manage Admins"
  },

  //User Dashboard
  userDashboard: {
    expertIn: "Expert In",
    knownFor: "Known For",
    walletCard: "Wallet",
    activeQuest: "Active Quest",
    noDevelopmentPlans: "No development plans active !",
    activityQueue: "Activity Queue",
    talentCard: "Talent Card",
    developmentCharter: "Development Charter",
    devchar: {
      suggested: "Suggested",
      fuctionalSkills: "Functional Skills",
      softSkills: "Soft Skills",
      news: "News",
      activityQueue: "Activity Queue",
      completedItems: "Completed Items"
    },
    sidebar: {
      dashboard: "Dashboard",
      boards: "Boards",
      community: "Community",
      wallet: "Wallet",
      notifications: "Notifications",
      myOrganizations: "My Organizations"
    },
    notifications: {
      learningActions: "Learning Actions",
      invites: "Admin Invites",
      manage: "Manage",
      acceptInvitation: "Accept Invitation",
      noNotifications: "No Notification Found!"
    },
    boards: {
      activeBoards: "Active Boards",
      archived: "Archived",
      noBoards: "No Boards Found!",
      curate: "Curate your own boards through your organization.",
      goToOrg: "Go to Organizations"
    },
    wallet: {
      connectWallet: "Connect Wallet",
      walletHistory: "Wallet History",
      status: "Status",
      date: "Date",
      amount: "Amount",
      transactions: "Transactions",
      type: "Type",
      details: "Details",
      done: "Done",
      noTransactions: "No Data Availaasdasdble"
    },
    profileDropDown: {
      createOrganization: "Create Organization",
      settings: "Settings",
      logout: "Logout"
    },
    settings: {
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email",
      dateOfBirth: "Date of Birth",
      gender: "Gender",
      about: "About",
      saveChanges: "Save Changes",
      account: "Account",
    }
  },
};
